import Vue from "vue";
import VueRouter from "vue-router";
import teacherPublicnumber from "./teacherPublicnumber";
import teacherApplyEmployment from "./teacherApplyEmployment";
import teacherSmallClassTime from "./teacherSmallClassTime";
import student from "./student";
import teacher from "./teacher";
import teacherGrowthSystem from "./teacherGrowthSystem";
import activity from "./activity";
import boss from "./boss";
import diamondStore from "./diamondStore";
import usercenter from "./usercenter";
import { utils } from "msb-public-library";
import { HIDE_PAGE_LIST } from "@/constants/blacklist";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: "1v1h5pages",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    teacherApplyEmployment,
    teacherPublicnumber,
    teacherSmallClassTime,
    student,
    teacher,
    teacherGrowthSystem,
    activity,
    boss,
    diamondStore,
    usercenter
  ]
});
/**
 * ios和安卓对微信config兼容
 * ios只会配置第一次进入的路由，后续路由无效
 */
router.afterEach((to, from) => {
  if (utils.client.ios) {
    if (window.entryUrl == "" || window.entryUrl == undefined) {
      window.entryUrl = "/1v1h5pages" + to.fullPath;
    }
  } else {
    window.entryUrl = "/1v1h5pages" + to.fullPath;
  }
});
/**
 * 页面黑名单，限制用户访问 20210609
 */
router.beforeEach((to, from, next) => {
  if (HIDE_PAGE_LIST.includes(to.fullPath)) {
    next(false);
    return;
  }

  next();
});

router.onError(error => {
  const pattern = /Loading chunk (\S*)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);

  console.log(error);
  console.log(isChunkLoadFailed);

  // @ts-ignore
  if (router.history) {
    console.log("enter");

    // @ts-ignore
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
      console.log("enter router replace");

      router.replace(targetPath);
      console.log("replace success?");
    }
  }
});

export default router;
